import profiles from '../../../../config/location_page_copy.json';
import details from '../../../../config/location_page_details.json';

const stateNames = { AZ: 'Arizona', CA: 'California', CO: 'Colorado', CT: 'Connecticut', FL: 'Florida', GA: 'Georgia', IL: 'Illinois', IN: 'Indiana', MD: 'Maryland', NV: 'Nevada', NY: 'New York', OR: 'Oregon', PA: 'Pennsylvania', TX: 'Texas', VA: 'Virginia', WA: 'Washington', DC: 'District of Columbia' };
const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export const locationPageCopy = location => {
  const city = location.city;
  const state = stateNames[String(location.state || '').toUpperCase()] || location.state;
  const key = Object.keys(profiles).find(name => normalize(name) === normalize(city));
  const candidate = key && profiles[key];
  const matchesState = candidate && (normalize(candidate.state) === normalize(state) || (key === 'Washington DC' && normalize(state) === 'district of columbia'));
  const profile = matchesState ? {...candidate, ...details[key]} : {};
  const region = profile.region || [city, state].filter(Boolean).join(', ');
  return {
    region,
    schemaState: state,
    areaType: 'City',
    hero: `Give your ${city} listing a stronger first impression. Professional real estate photography and media help buyers see the space, light, and details that make your property stand out.`,
    meta: `Professional real estate photography in ${region}. Explore listing photos, video, floor plans, 3D tours, and virtual staging. Book Modern Angles online with 24-hour media delivery.`,
    focus: 'Professional HDR photography balances interior light and window views while highlighting the rooms and details buyers want to see.',
    prepare: 'Share property access, preparation details, and any special requests ahead of your shoot.',
    question: 'How should I prepare the property for photography?',
    answer: 'Clean and stage the property, clear everyday clutter, and make sure the photographer can access the home. Share entry instructions and any building requirements when booking.',
    planningTitle: `Plan the photography around your ${city} property`,
    booking: 'Enter your full property address to review available services and pricing, choose a photographer and available appointment, and provide contact and access details before checkout.',
    ...profile,
    region
  };
};

export const locationPageFaqs = (location, copy = locationPageCopy(location)) => [
  [copy.question, copy.answer], ...(copy.faqs || []),
  [`How do I check pricing and appointment availability in ${copy.region}?`, copy.booking]
];

// Only reuse the server's public data for this exact location, including on back navigation.
export const locationPageBootstrap = slug => {
  if (typeof document === 'undefined') return null;
  const element = document.getElementById('modern-angles-location');
  if (!element) return null;
  try {
    const location = JSON.parse(element.textContent);
    return location.slug === slug ? location : null;
  } catch (_) { return null; }
};
